(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lsa-portfolio-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lsa-portfolio]').forEach(function(root){var hero=root.querySelector('[data-lsa-hero]');if(!hero||hero.dataset.pointerReady)return;hero.dataset.pointerReady='true';hero.addEventListener('pointermove',function(event){if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;var rect=hero.getBoundingClientRect();var x=((event.clientX-rect.left)/rect.width-.5)*26;var y=((event.clientY-rect.top)/rect.height-.5)*26;hero.style.setProperty('--px',x+'px');hero.style.setProperty('--py',y+'px')});hero.addEventListener('pointerleave',function(){hero.style.setProperty('--px','0px');hero.style.setProperty('--py','0px')})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
